<template>
  <res-dialog title="Warning: Duplicate Budget"
              :titleClass="'resRed darken-1 white--text'"
              :showDialog="showDialog"
              :showTitleIcon="true"
              :smallTitleIcon="true"
              iconColor="white"
              saveButtonText="YES, PROCEED"
              :saveDisabled="false"
              cancelButtonText="CANCEL"
              cancelButtonWidth="80"
              :defaultButtonAction="confirm"
              @save="confirm"
              @cancel="cancel">
    <v-container>
      <v-card-text>
        <span class="font-weight-500">
          There are already existing budget versions for this year, accounting basis, and property. You can either create a new version or overwrite an existing version's data.
        </span><br /><br />
        <span class="font-weight-500">
           To create a new version, set the drop-down to [New Version]. Otherwise, select a version to overwrite. If an archived version is selected, it will be unarchived. Published and approved versions cannot be overwritten and are not provided as options.
        </span><br />
        <res-select id="iteration-selector" v-model="selectedIteration" :items="iterations" attach="#iteration-selector" return-object></res-select>
        <br />
        <span class="font-weight-500">
          Are you sure you want to proceed?
        </span>
      </v-card-text>
    </v-container>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';
  import ResSelect from '@/components/base/ResSelect.vue';

  import budgetService from '@/services/budget';

  export default {
    components: {
      ResDialog,
      ResSelect
    },
    data: function () {
      return {
        setHeight: '30',
        iterations: [
          { text: '[New Version]', value: null }
        ],
        selectedIteration: { text: '[New Version]', value: null }
      };
    },
    props: {
      height: {
        type: Number
      },
      maxWidth: {
        type: Number
      },
      showDialog: {
        type: Boolean
      },
      width: {
        type: Number
      },
      budgetId: {
        type: String
      }
    }, 
    methods: {
      cancel() {
        this.$emit('cancel', true)
      },
      confirm() {
        let budgetIterationId = this.selectedIteration ? this.selectedIteration.value : null;
        this.$emit('confirm', budgetIterationId);
      }
    },
    computed: {  
      calculateHeight() {
        return "height:" + this.setHeight + "px";
      }
    },
    async mounted() {
      let response = await budgetService.getBudgetIterations(this.budgetId);
      response.forEach((i) => {
        if (i.isPublished || i.isApproved || i.isRetired || i.isPending || i.isArchived) {
          return; // cannot overwrite approved/published/retired/pendingapproval versions
        }
        this.iterations.push({ text: i.display, value: i.budgetIterationId});
      });
    }
  }
</script>
